import 'react-datetime/css/react-datetime.css'
import DateFnsUtils from '@date-io/date-fns'
import { DatePicker as DatePickerM, MuiPickersUtilsProvider } from '@material-ui/pickers'
import esLocale from 'date-fns/locale/es'
import React from 'react'
import Autosuggest from 'react-autosuggest'
import { ButtonToolbar, FormControl, FormGroup, FormLabel, ToggleButton, ToggleButtonGroup } from 'react-bootstrap'
import DatePicker from 'react-datetime'

import MaterialColorPicker from '../MaterialColorPicker/MaterialColorPicker'
import { COLORES } from '../../config/colores'

const getSuggestionRender = (attr) => {
  return (suggestion) => (
    <div>
      {suggestion[attr]}
    </div>
  )
}

function getValidationState (touched, error) {
  if (!touched) return null
  return error ? 'valid' : 'invalid'
}

function renderError (touched, error) {
  return touched && error && <FormControl.Feedback type={error}><strong>{error}</strong></FormControl.Feedback>
}

export function renderAutocomplete ({
  input,
  label,
  meta: { touched, error },
  doNotIncludeFeedback,
  children,
  onChangeInput,
  entity,
  onBlurInput,
  onSuggestionSelected,
  ...props
}) {
  const {
    values
  } = props

  const suggestions = values.map(v => {
    const s = {}
    s[entity] = v
    return s
  })

  input.value = String(input.value)
  const renderer = getSuggestionRender(entity)

  return (
    <FormGroup
      controlId={getValidationState(touched, error)}
    >
      <FormLabel>{label}</FormLabel>
      <Autosuggest
        suggestions={suggestions}
        onSuggestionsFetchRequested={onChangeInput}
        onSuggestionsClearRequested={() => []}
        getSuggestionValue={s => {
          input.value = s[entity]
          return s[entity]
        }}
        renderSuggestion={renderer}
        highlightFirstSuggestion
        onSuggestionSelected={
          (e, obj) => onSuggestionSelected(e, obj, input)}
        inputProps={{
          ...input,
          onBlur: (e, obj) => onBlurInput(e, obj, input)
        }}
        {...props}
      />
      {renderError(touched, error)}
    </FormGroup>
  )
}

export function renderTextField ({
  input,
  label,
  meta: { touched, error },
  doNotIncludeFeedback,
  children,
  upperCase = false, // se indica cuando el valor debe estar en mayusculas siempre
  wrapperStyle = {},
  ...props
}) {
  const handleChange = (event) => {
    const { value } = event.target
    const upperCasedValue = value.toUpperCase()
    input.onChange(upperCasedValue)
  }

  return (
    <FormGroup
      style={wrapperStyle}
      controlId={getValidationState(touched, error)}
    >
      <FormLabel>{label}</FormLabel>
      <FormControl
        {...input} {...props}
        onChange={upperCase ? handleChange : input.onChange} // aplica handleChange si upperCase esta indicado
      />
      {renderError(touched, error)}
      {children}
    </FormGroup>
  )
}

export function renderTextAreaField ({
  input,
  label,
  meta: { touched, error },
  doNotIncludeFeedback,
  children,
  ...props
}) {
  return (
    <FormGroup>
      <FormLabel>{label}</FormLabel>
      <FormControl as='textarea'
        {...input} {...props}>
        {children}
        {input.value}
      </FormControl>
      {renderError(touched, error)}
    </FormGroup>
  )
}

export function renderSelectField ({
  input,
  label,
  meta: { touched, error },
  doNotIncludeFeedback,
  children,
  wrapperStyle = {},
  ...props
}) {
  return (
    <FormGroup style={wrapperStyle}>
      <FormLabel>{label}</FormLabel>
      <FormControl as='select'
        {...input} {...props}>
        {children}
        {input.value}
      </FormControl>
      {renderError(touched, error)}
    </FormGroup>
  )
}

export function renderSelectFieldWithOptions ({
  input,
  label,
  options,
  meta: { touched, error },
  ...props
}) {
  return (
    <FormGroup>
      <FormLabel>{label}</FormLabel>
      <FormControl as='select'
        {...input} {...props}>
        <option value={null} key={0} />
        {options.map(option => <option
          value={option.etiqueta}
          key={option.etiqueta}
        >
          {option.etiqueta}
        </option>
        )}
      </FormControl>
      {renderError(touched, error)}
    </FormGroup>
  )
}

export function renderDateField ({
  input,
  label,
  dateFormat,
  meta: { touched, error },
  ...rest
}) {
  return (
    <FormGroup>
      <FormLabel>{label}</FormLabel>
      <DatePicker
        timeFormat={false}
        dateFormat={dateFormat || 'YYYY/MM/DD'}
        value={input.value}
        onBlur={input.onBlur}
        onChange={input.onChange}
        {...rest}
      />
      {rest.placeholder}
      {renderError(touched, error)}
    </FormGroup>
  )
}

export function renderColorPickerField ({
  input,
  label,
  dateFormat,
  meta: { touched, error },
  ...rest
}) {
  if (!input.value) {
    input.onChange(rest.initColor)
  }
  return (
    <FormGroup>
      <FormLabel>{label}</FormLabel>
      <MaterialColorPicker
        initColor={rest.initColor}
        onSelect={(event) => {
          input.onChange(event.target.value)
        }}
        style={{ width: '100%', backgroundColor: '#c7c7c7' }}
      />
      {renderError(touched, error)}
    </FormGroup>
  )
}

export function renderCheckboxesField ({
  name,
  input,
  label,
  meta: { touched, error },
  options,
  ...rest
}) {
  return (
    <FormGroup>
      <FormLabel>{label}</FormLabel>
      <ButtonToolbar>
        <ToggleButtonGroup
          className='checkboxes-group'
          type='checkbox'
          onChange={input.onChange}
          value={input.value}
        >
          {options.map((option, index) => (
            <ToggleButton
              key={index}
              variant={
                input.value.includes(option.fieldName)
                  ? 'primary' : 'default'
              }
              value={option.fieldName}
            >
              {option.name}
            </ToggleButton>
          ))}
        </ToggleButtonGroup>
      </ButtonToolbar>
      {renderError(touched, error)}
    </FormGroup>
  )
}

export function renderRadio ({
  name,
  input,
  meta: { touched, error },
  options,
  ...rest
}) {
  return (
    <FormGroup>
      <ButtonToolbar>
        <ToggleButtonGroup
          className='checkboxes-group'
          type='radio'
          onChange={input.onChange}
          name='name'
          value={input.value}
        >
          {options.map((option, index) => (
            <ToggleButton
              key={index}
              variant={
                input.value.includes(option.fieldName)
                  ? 'primary' : 'default'
              }
              value={option.fieldName}
              exclusive='true'
            >
              {option.name}
            </ToggleButton>
          ))}
        </ToggleButtonGroup>
      </ButtonToolbar>
      {renderError(touched, error)}
    </FormGroup>
  )
}

export function renderRadioField ({
  name,
  input,
  meta: { touched, error },
  options,
  className = null,
  wrapperStyle = {},
  ...rest
}) {
  return (
    <FormGroup style={wrapperStyle} >
      <ButtonToolbar style={{ width: 'auto' }} >
        <ToggleButtonGroup
          className={className || 'checkboxes-group'}
          type='radio'
          onChange={input.onChange}
          name='name'
          value={input.value}
        >
          {options.map((option, index) => (
            <ToggleButton
              key={index}
              style={{
                backgroundColor: input.value.includes(option.fieldName) ? COLORES.grey.mediumDark : COLORES.grey.light,
                color: input.value.includes(option.fieldName) ? '#ffffff' : COLORES.grey.dark,
                border: 'none',
                borderRadius: '8px',
                margin: '8px',
                outline: 'none',
                fontWeight: 'bold',
                fontSize: '1rem'
              }}
              variant='primary'
              value={option.fieldName}
              exclusive='true'
            >
              {option.name}
            </ToggleButton>
          ))}
        </ToggleButtonGroup>
      </ButtonToolbar>
      {renderError(touched, error)}
    </FormGroup>
  )
}

export function renderDateMaterialField ({
  input,
  label,
  format,
  meta: { touched, error },
  ...rest
}) {
  return (
    <FormGroup>
      <FormLabel>{label}</FormLabel>
      <MuiPickersUtilsProvider utils={DateFnsUtils} locale={esLocale}>
        <DatePickerM
          margin='normal'
          format='yyyy/MM/dd'
          value={input.value}
          onBlur={input.onBlur}
          onChange={input.onChange}

          cancelLabel='Cancelar'
          animateYearScrolling
          {...rest}
        />
      </MuiPickersUtilsProvider>
      {rest.placeholder}
      {renderError(touched, error)}
    </FormGroup>
  )
}
